<template>
  <el-dialog
    :title="'导入文件错误信息提示'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-input
      :disabled="true"
      type="textarea"
      :rows="2"
      placeholder=""
      :autosize="{ minRows: 2, maxRows: 100}"
      v-model="textarea">
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
        return {
          visible: false,
          textarea: ''
        }
    },
    methods: {
      init (data) {
        this.visible = true
        this.textarea = data
      },
    }
  }
</script>
